import { API, BASE_API, SIM, LOGO, ZONA, GMAP_KEY, COPYRIGHT, PORTAL, LEARNDASH, SIMPKB, BELAJARID, PESERTA_COACHING_CLINIC } from "@/const";

const Consts = {
  install(Vue) {
    // 4. add an instance method
    Vue.prototype.$consts = {
      API,
      BASE_API,
      SIM,
      GMAP_KEY,
      LOGO,
      COPYRIGHT,
      PORTAL,
      ZONA,
      LEARNDASH,
      SIMPKB,
      PESERTA_COACHING_CLINIC,
      BELAJARID
    };
  }
};

export default Consts;
